import logo from '../assets/logo.svg';
import menu from '../assets/icon-hamburger.svg';
import close from '../assets/icon-close.svg';
import hero from '../assets/illustration-devices.svg';

export default {
    logo,
    menu,
    close,
    hero,
};